// Models
import { createMyDocumentStoreDefaultModel } from './my-document/my-document.store'
import { createProfileStoreDefaultModel } from './profile/profile.store'
import { createAdditionalQuestionStoreDefaultModel } from './additional-question/additional-question.store'

const personalDataModels = {
  myDocument: createMyDocumentStoreDefaultModel(),
  profile: createProfileStoreDefaultModel(),
  additionalQuestion: createAdditionalQuestionStoreDefaultModel()
}

export { personalDataModels }
